export const MY_CONSUMPTION_LIST = 'MY_CONSUMPTION_LIST'



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/records-of-consumption/store/mutations-types.js